import React from "react";
import { useTranslation } from "react-i18next";
import "./HeroMillionsOnly.css";
import Mini1 from "../Comms/MiniSaver1";

const HeroMillionsOnly = () => {
 const { t } = useTranslation();
  return (
  <section className="heroMillionsOnly heroMillionsOnly--blue">
  <h1 className="heroMillionsOnly-title"> {t("h1")}   </h1>

  <section className="hero-miss-credits">
    <div className="hero-miss-credits__inner">
      <p className="hero-miss-credits__reasons"> {t("h2")}</p>
      <p className="hero-miss-credits__reasons"> {t("h3")}</p>
      <p className="hero-miss-credits__reasons"> {t("h4")}</p>
    </div>
  </section>  
<Mini1/>
</section>

  );
};

export default HeroMillionsOnly;
